var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AbstractModule } from '@g.frame/core';
import { Object3D } from 'three';
import { Loader, LoaderEventsName } from '@g.frame/common.loaders';
import QuestHandView from './QuestHandView';
import { OculusQuestModule } from '@g.frame/oculus.quest';
import { FingerTouchActionController } from './FingerTouchActionController';
export class QuestHandViewModule extends AbstractModule {
    constructor() {
        super();
        this.container = new Object3D();
    }
    preInit() {
        return __awaiter(this, void 0, void 0, function* () {
            console.info('Module pre initialization.. Just make sure, that module is supported.');
            return {
                enabled: true
            };
        });
    }
    onInit(data) {
        return __awaiter(this, void 0, void 0, function* () {
            console.info('Module initialization. Create all instances.');
            return [
                this.questHandView = new QuestHandView(this.container),
                this.fingerTouchAC = new FingerTouchActionController()
            ];
        });
    }
    getModuleContainer() {
        return this.container;
    }
    afterInit(agents, modules) {
        const loader = agents.get(Loader);
        this.questHandView.prepareResources(loader);
        const oculusQuestModule = modules.get(OculusQuestModule);
        loader.on(LoaderEventsName.loaded, () => {
            var _a;
            (_a = oculusQuestModule.oculusQuestManager) === null || _a === void 0 ? void 0 : _a.setXRControllerView(this.questHandView);
        });
        if (oculusQuestModule && oculusQuestModule.oculusQuestModel)
            this.fingerTouchAC.init(oculusQuestModule.oculusQuestModel, this.questHandView);
        console.info('Module after initialization. Here you can start save the World.');
    }
    onUpdate(params) {
        // console.info('Module on update function. Use it to update instances.');
    }
    onDestroy() {
        console.info('Module destroy function. Use it to destroy and dispose instances.');
    }
    onResume() {
    }
    onPause() {
    }
}
